import { useEffect, useState } from "react";

// Responsive breakpoints
const MOBILE_MAX = 767;
const TABLET_MIN = 768;
const TABLET_MAX = 1279;
const DESKTOP_MIN = 1280;

export default function useResponsive() {
  const [width, setWidth] = useState<number>(typeof window !== "undefined" ? window.innerWidth : 1200);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = width <= MOBILE_MAX;
  const isTablet = width >= TABLET_MIN && width <= TABLET_MAX;
  const isDesktop = width >= DESKTOP_MIN;

  return { isMobile, isTablet, isDesktop, width };
}

// Responsive: This hook provides booleans for mobile/tablet/desktop and current width.